export default __webpack_public_path__ + "static/media/blade-fall.cdb5f1bf.svg";